import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createdCardIsFilteredTitle: {
		id: 'backlog.flags.card-create-filtered.created-card-is-filtered-title',
		defaultMessage: '{cardKey} has been created.',
		description: '',
	},
	createdCardIsFilteredDescription: {
		id: 'backlog.flags.card-create-filtered.created-card-is-filtered-description',
		defaultMessage: "It's hidden by your current filter.",
		description: '',
	},
	createdCardIsFilteredLink: {
		id: 'backlog.flags.card-create-filtered.created-card-is-filtered-link',
		defaultMessage: 'View issue',
		description: '',
	},
	createdCardIsFilteredLinkIssueTermRefresh: {
		id: 'backlog.flags.card-create-filtered.created-card-is-filtered-link-issue-term-refresh',
		defaultMessage: 'View issue',
		description: '',
	},
});
